(()=>{
 if(customElements.get('pdc-studio-models'))return;
 const maps=new Map();
 class PdcStudioModels extends HTMLElement{
  connectedCallback(){
   this.seen=new WeakSet();
   this.visibility='IntersectionObserver' in window?new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){this.visibility.unobserve(entry.target);this.prepare(entry.target);}}},{rootMargin:'160px'}):null;
   this.changes=new MutationObserver(()=>this.scan());
   this.changes.observe(this,{childList:true,subtree:true});
   this.load();
  }
  disconnectedCallback(){this.visibility?.disconnect();this.changes?.disconnect();}
  async load(){
   const url=this.dataset.pdcModelMap;if(!url)return;
   try{
    if(!maps.has(url))maps.set(url,fetch(url).then(r=>{if(!r.ok)throw Error('Image map unavailable');return r.json();}).catch(error=>{maps.delete(url);throw error;}));
    this.mapping=await maps.get(url);if(this.isConnected)this.scan();
   }catch(error){this.dataset.modelState='originals';}
  }
  scan(){
   if(!this.mapping)return;
   for(const card of this.querySelectorAll('[data-pdc-product]')){
    if(this.seen.has(card))continue;this.seen.add(card);
    if(this.visibility)this.visibility.observe(card);else this.prepare(card);
   }
  }
  prepare(card){
   const item=this.mapping[card.dataset.pdcProduct];
   if(!item?.approved||!item.model||String(item.source_image_id)!==card.dataset.sourceImage)return;
   const image=new Image();image.className='pdc-s-model';image.width=1200;image.height=1500;image.decoding='async';image.alt=item.alt||card.querySelector('a').getAttribute('aria-label')+' — on model';
   image.onload=()=>{if(!card.isConnected)return;card.querySelector('.pdc-s-media>a').append(image);card.classList.add('pdc-s-ready');};
   image.src=item.model;
  }
 }
 customElements.define('pdc-studio-models',PdcStudioModels);
})();
